/*export class GameScene extends Phaser.Scene {
    constructor() {
        super({ key: "GameScene" });
    }
 
    create() {
        this.add.text(10, 10, "HELLO WORLD, YOU BAG O'SHITE");
    }
}*/

//import 'phaser';

//import sky from './assets/skyline_48x40.png';
var sky = require('./assets/skyline_48x40.png');
//import plat from './assets/girder_hole_16x8.png';
var plat = require('./assets/girder_hole_16x8.png');
//import ground from './assets/platform.png';
var ground = require('./assets/platform.png');
//import player from './assets/maghead_16x16_ss_idle_and_hang.png';
var player = require('./assets/maghead_16x16_ss_idle_and_hang.png');
//import magzap from './assets/magzap_8x8.png';
var magzap = require('./assets/magzap_8x8.png');

//import au_bump from './assets/bump1.wav';
var au_bump = require('./assets/bump1.wav');
//import au_clank from './assets/clank2.wav';
var au_clank = require('./assets/clank2.wav');
//import au_magnet from './assets/magnet3.wav';
var au_magnet = require('./assets/magnet3.wav');

//import fontTx_large from './assets/fonts/InkFree_20_0.png';
var fontTx_large = require('./assets/fonts/InkFree_20_0.png');
//import fontInf_large from './assets/fonts/InkFree_20.fnt';
var fontInf_large = require('./assets/fonts/InkFree_20.fnt');
//import fontTx_small from './assets/fonts/SmallFonts_10_0.png';
var fontTx_small = require('./assets/fonts/SmallFonts_10_0.png');
//import fontInf_small from './assets/fonts/SmallFonts_10.fnt';
var fontInf_small = require('./assets/fonts/SmallFonts_10.fnt');
//import fontTx_info from './assets/fonts/System_8_0.png';
var fontTx_info = require('./assets/fonts/System_8_0.png');
//import fontInf_info from './assets/fonts/System_8.fnt';
var fontInf_info = require('./assets/fonts/System_8.fnt');

//import { Time } from 'phaser';
//import { SmoothDamp, SmoothDampData } from './utils.js';
var utils = require('./utils.js');

class MagnetZap extends Phaser.GameObjects.Sprite
{
    startPosY;

    constructor(scene, x, y)
    {
        super(scene, x, y, 'magzap');

        this.startPosY = y;

        scene.add.existing(this);
        scene.physics.add.existing(this);
        
        this.body.setAllowGravity(false);
        //this.body.setMaxVelocityY(0);
        this.body.setEnable(true);

        this.body.setDrag(0, 0);
        //this.body.pushable = false;
        //this.body.setImmovable(true);   // NB. Platforms have to be 'immovable' to transfer friction
        //this.body.setBounce(1, 0);

        this.body.setSize(4, 4);
        this.setAlpha(.8);
        this.setBlendMode('ADD');

        this.body.checkCollision.up = true;
        this.body.checkCollision.down = false;
        this.body.checkCollision.left = false;
        this.body.checkCollision.right = false;

        this.body.setVelocityY(-160);
        this.body.setAngularVelocity(Math.random()*640 - 320);

        this.body.onCollide = true;
        //this.body.onCollideCallback = () => { console.info("!!"); this.onExpireCall() };
    }

    checkExpired(callback) {
        if (this.body && this.body.y < this.startPosY - 64) {
            callback();
        }
    }

    update() {
        this.alpha -= .03;
    }
}

class Platform extends Phaser.GameObjects.Image
{
    frameWidth;
    speed;

    constructor(scene, x, level, levelHeight, prevplat)
    {
        super(scene, x, 160 - level * levelHeight, 'plat');

        this.frameWidth = 192;//.config.frameWidth;
        
        scene.add.existing(this);
        scene.physics.add.existing(this);
        
        this.body.setAllowGravity(false);
        this.body.setMaxVelocityY(0);
        this.body.setEnable(true);

        this.body.setDrag(0, 0);
        //this.body.pushable = false;
        this.body.setImmovable(true);   // NB. Platforms have to be 'immovable' to transfer friction
        this.body.setBounce(1, 0);

        this.body.setSize(16, 8);

        this.body.checkCollision.up = true;
        this.body.checkCollision.down = true;//false;
        this.body.checkCollision.left = true;
        this.body.checkCollision.right = true;

        this.body.setFrictionX(1);

        const minSpeed = 24;
        const maxVariation = 128;
        const levelFactor = level * 5;
        let tries = 0;
        do {
            this.speed = Math.random() * maxVariation + minSpeed;
            this.speed = Math.min(this.speed, minSpeed + levelFactor);
        } while (tries++ < 30 && prevplat != null && Math.abs((Math.abs(prevplat.speed) - Math.abs(this.speed))) < levelFactor/2);
        //if (prevplat) console.info(prevplat.speed);
        this.body.setMaxSpeed(this.speed);

        if (Math.round(level/2) == level/2) this.speed *= -1;

        this.body.setVelocityX(this.speed);

        this.body.setCollideWorldBounds(true);
    }

    update()
    {
        /*if (this.x > (this.frameWidth)) this.speed = Math.abs(this.speed) * -1;
        if (this.x < (0)) this.speed = Math.abs(this.speed) * 1;

        this.body.setVelocityX(this.speed);*/
        

        //this.body.angularVelocity = 100;
    }
}

export class GameScene extends Phaser.Scene
{
    constructor ()
    {
        super();
    }

    player;
    platforms;
    sky;
    ground;
    //magnetZap;
    magnetZaps;
    textCurrentLevel;
    textBestLevel;
    textInstructions;


    magnetizing = false;
    platformMagnetized;
    ticksLastBolt = 0;
    magZapXOffset = 4;
    camYPos = 0;
    smoothDampData;
    smoothDampDataBestText;

    bestYPos = 0;
    bestLevel = 0;
    currentLevel = 0;

    bestTextYpos = 0;
    bestTextOnscreen = false;

    audio_magnet;
    audio_bump;
    audio_clank;

    magnetKey;

    preload ()
    {
        //this.load.css('styles', './styles.css');

        //this.load.setPath('assets/');
        this.load.image('sky', sky);
        this.load.image('plat', plat);
        this.load.image('ground', ground);
        this.load.spritesheet('player', player, {frameWidth:16, frameHeight:16});
        this.load.image('magzap', magzap);

        this.load.audio('magnet', au_magnet);
        this.load.audio('bump', au_bump);
        this.load.audio('clank', au_clank);

        // FONTS

        this.load.bitmapFont('largefont', fontTx_large, fontInf_large);
        this.load.bitmapFont('smallfont', fontTx_small, fontInf_small);
        this.load.bitmapFont('infofont', fontTx_info, fontInf_info);
        /*this.load.bitmapFont({
            key: 'largefont',
            textureURL: 'assets/fonts/FixedSys_16_0.png',
            fontDataURL: 'assets/fonts/FixedSys_16.fnt'
        });*/

        /*this.load.image('libs', '../assets/libs.png');
        this.load.glsl('bundle', '../assets/plasma-bundle.glsl.js');*/
        
        this.smoothDampData = new utils.SmoothDampData();
        this.smoothDampDataBestText = new utils.SmoothDampData();
    }

    create ()
    {
        this.cameras.main.setRoundPixels(false);

        // ** SKY & GROUND

        this.sky = this.add.image(192/2, 160/2, 'sky').setTint(0x333377,0x333377,0x111111,0x111111).setDisplaySize(192,160);//.setScale(4);
        this.ground = this.add.image(192/2, 174, 'ground');

        this.sky.setDepth(-10);

        
        // ** PLATFORMS

        this.platforms = this.add.group({
            runChildUpdate: true
        });
        var prevplat = null;
        for (var i = 0; i < 128; i++) { //130 max
            const newplat = new Platform(this, 192/2, i+1, 32, prevplat);
            this.platforms.add(newplat);
            prevplat = newplat;
        }

        // ** ZAPS GROUP

        this.magnetZaps = this.add.group({
            runChildUpdate: true
        });


        // ** PLAYER

        var config = {
            key: 'idleAnim',
            frames: this.anims.generateFrameNumbers('player', { start: 0, end: 3, first: 0 }),
            frameRate: 6,
            repeat: -1
        };
        this.anims.create(config);

        var config = {
            key: 'hangAnim',
            frames: this.anims.generateFrameNumbers('player', { start: 4, end: 7 }),
            frameRate: 6,
            repeat: -1
        };
        this.anims.create(config);
        
        // The player and its settings
        this.player = this.physics.add.sprite(192/2, 150, 'player').play('idleAnim');
        this.player.setBounce(0.3);

        this.player.body.pushable = true;
        this.player.body.setFrictionX(1);
        this.player.body.setDragX(96);
        this.player.body.mass = 100;

        // Set up a collision pair between player and patform-group
        this.physics.add.collider(this.player, this.platforms, (plyr, plat) => {
            this.onPlayerLand(plyr, plat);
        });
        // ... and ground
        /*this.physics.add.collider(this.player, this.ground, (plyr, grnd) => {
            this.onPlayerLand(plyr, grnd);
        });*/
        this.player.body.onWorldBounds = true;
        this.physics.world.on('worldbounds', this.onPlayerWorldBounds, this);   // NB context is passed here (this)
        
        //this.physics.world.wrap(this.player);

        this.player.setCollideWorldBounds(true);


        



        // ** TEXT/UI

        this.textCurrentLevel = this.add.bitmapText(2, 0, 'largefont', "");
        this.textCurrentLevel.setDropShadow(2, 2, 0x000000, .7);
        this.textCurrentLevel.fontSize = 20;
        //this.textCurrentLevel.setStroke('black', 1);

        //this.textCurrentLevel.blendMode = Phaser.BlendModes.HARD_LIGHT;
        this.textBestLevel = this.add.bitmapText(2, 0, 'smallfont', "");
        this.textBestLevel.alpha = .25;
        this.textBestLevel.tint = 0x00ff44;
        //this.textBestLevel.setBlendMode('ADD');

        /*this.textBestLevel.setFontSize(10);
        this.textBestLevel.scale = 1;
        this.textBestLevel.setStroke('black', 1);
        //this.textBestLevel.setColor('green');*/
        this.textBestLevel.setDepth(-1);


        this.textInstructions = this.add.bitmapText(0, 160/2, 'infofont', "- MagnaTed -\nHold the left mouse button or <spacebar> to activate Ted's magnet. Release it to fall. How high can you go?\n GOOD LUCK!");
        this.textInstructions.setCenterAlign();
        this.textInstructions.setMaxWidth(190);
        this.textInstructions.x = (192 - this.textInstructions.width) / 2;
        this.textInstructions.y = (160 - this.textInstructions.height) / 2;
        this.textInstructions.alpha = 1;
        this.textInstructions.tint = 0x9999ff;
        this.textInstructions.setDropShadow(2, 1, 0x000000, .7);

        // ** AUDIO

        this.audio_magnet = this.sound.add('magnet');
        this.audio_bump = this.sound.add('bump');
        this.audio_clank = this.sound.add('clank');


        // ** CONTROL(S)
        this.magnetKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);

        this.updateScore();
    }

    update ()
    {
        let curYPos = this.player.body.y;

        this.currentLevel = Math.round((160 - curYPos) / 32 - .5);
        //this.bestLevel = Math.max(this.currentLevel, this.bestLevel);

        let yp = curYPos;

        yp = Math.min(yp, 160/2);
        let ydel = yp - this.camYPos;
        //this.camYPos += ydel * .05;

        this.camYPos = utils.SmoothDamp(this.camYPos, yp, this.smoothDampData, 2.0, 50.0, 0.1);

        this.cameras.main.centerOn(192/2, this.camYPos);
        this.sky.y = this.camYPos;

        this.magnetZaps.getChildren().forEach(mg => {
            if (mg) mg.checkExpired( ()=>{mg.destroy();} )
        });


        this.ticksLastBolt++;

        //if (this.game.input.activePointer.isDown && this.magnetZaps.getLength() < 3)
        if (this.game.input.activePointer.isDown || this.magnetKey.isDown)
        {
            this.textInstructions.alpha = 0;

            if (!this.magnetizing) {
                this.audio_magnet.play();
                this.audio_magnet.setVolume(1);
            }
            this.magnetizing = true;

            if (this.platformMagnetized) this.pullPlayerUp(this.platformMagnetized);
            
            if (!this.platformMagnetized && this.magnetZaps.getLength() < 6 && this.ticksLastBolt > 4) {
                this.ticksLastBolt = 0;
                this.magZapXOffset *= -1;
                let newzap = new MagnetZap(this, this.player.x + this.magZapXOffset, this.player.y-10);
                this.magnetZaps.add(newzap);
                this.physics.add.collider(newzap, this.platforms, (zap, plat) => {this.pullPlayerUp(plat); zap.destroy(); });
            }
        }
        else {

            this.player.anims.resume();
            this.player.anims.play('idleAnim', true);
            if (this.platformMagnetized != null) {      // remove clause to enable change of magnetization
                this.player.body.velocity.x = this.platformMagnetized.body.velocity.x;
            }
            //this.platformMagnetized = null;
            this.stopMagnetizing();
            this.audio_magnet.setVolume(this.audio_magnet.volume * .8);
        }


        this.textCurrentLevel.y = this.camYPos - 160/2;


        let screenTop = this.camYPos - 156/2;
        let screenBottom = 160-10;
        let bestYPos = 160 - (this.bestLevel * 32 + 10);
        bestYPos = Math.min(bestYPos, screenBottom);
        bestYPos = Math.max(bestYPos, screenTop);

        this.bestTextOnscreen = bestYPos != screenTop;

        //this.textBestLevel.y = bestYPos;
        this.textBestLevel.y = utils.SmoothDamp(this.textBestLevel.y, bestYPos, this.smoothDampDataBestText, this.bestTextOnscreen ? 2.0 : 0.1, 50.0, 0.1);

        this.textBestLevel.x = 192 - 2 - this.textBestLevel.width;
    }

    updateScore()
    {
        this.bestLevel = Math.max(this.currentLevel, this.bestLevel);
        
        this.textCurrentLevel.text = "Level: "+this.currentLevel;
        this.textBestLevel.text = this.bestTextOnscreen ? ("- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - BEST: "+this.bestLevel+" -") : ("BEST: "+this.bestLevel+"  ");
        this.textBestLevel.alpha = this.bestTextOnscreen ? .25 : 1;
        this.textBestLevel.tint = this.bestLevel == 0 ? 0x000000 : (this.bestTextOnscreen ? 0x00ff44 : 0xffffff);

        /*let topColor = new Phaser.Display.Color(64,64,128,255);
        let bottomColor = new Phaser.Display.Color(64,1,1,255);
        
        const heightFactor = Math.min(1, this.currentLevel/1);

        topColor.lighten(heightFactor*10);
        bottomColor.lighten(heightFactor*100);
        bottomColor.desaturate(heightFactor*100);

        this.sky.setTint(topColor.color,topColor.color,bottomColor.color,bottomColor.color);*/
    }

    /*expireZap() {
        if (this.magnetZap) this.magnetZap.destroy();
        this.magnetZap = null
    }*/

    onPlayerWorldBounds(playerBody) {
        let deg = -playerBody.velocity.y;
        //console.info(this.onPlayerLand);
        if (deg > 0)
            this.onPlayerLand(this.player, this.ground);
    }

    onPlayerLand(player, hitThing) {
        
        // assist by reducing x-velocity
        player.body.velocity.x *= .5;

        //if (hitThing && hitThing != this.platformMagnetized) this.stopMagnetizing(); //this.platformMagnetized = null;
        
        //let deg = Math.abs(player.body.velocity.y);
        let deg = -player.body.velocity.y;
        
        if (deg > 2) {
            this.audio_bump.setVolume(deg/16);
            this.audio_bump.setDetune(Math.min(512, (-512 + deg * 16)));
            this.audio_bump.play();
        }
        if (deg > 0)
            this.updateScore();

        if (deg < 0)
        {
            
            if (this.audio_magnet.volume == 1) {
                //this.audio_clank.setVolume(-deg/16);
                this.audio_clank.setDetune(-64 + this.currentLevel * 8);
                this.audio_clank.play();
            }
            this.audio_magnet.setVolume(this.audio_magnet.volume * .7);
        }
    }

    stopMagnetizing() {
        /*if (this.magnetizing)
                this.audio_magnet.pause();*/
        this.magnetizing = false;

        this.platformMagnetized = null;
    }

    pullPlayerUp(platform) {

        this.player.body.setVelocityY(-256);
        
        //this.player.anims.pause();
        this.player.anims.play('hangAnim', true);
        
        let xdif = this.player.body.x - platform.body.x;
        this.player.body.x -= xdif / 3;
        //this.player.body.x = platform.body.x;
        
        if (!this.platformMagnetized) this.platformMagnetized = platform;
    }
}



/*const config = {
    type: Phaser.AUTO,
    backgroundColor: '#125555',
    width: 800,
    height: 600,
    scene: Demo
};*/

//const game = new Phaser.Game(config);